// S-B3: Company Payment API Endpoints
import { apiClient } from './client';

export interface LinkTokenResponse {
  link_token: string;
  expiration: string;
}

export interface ExchangePublicTokenRequest {
  public_token: string;
}

export interface ExchangePublicTokenResponse {
  ok: boolean;
}

export interface CompanyPaymentProfileResponse {
  has_linked_account: boolean;
  provider?: string;
  status?: string;
}

export interface BankAccount {
  id: string;
  institution_name: string;
  account_name: string;
  mask: string;
  account_type: string;
  status: string;
  is_default: boolean;
  verified_at?: string;
  created_at: string;
  updated_at: string;
}

export interface BankAccountsResponse {
  accounts: BankAccount[];
}

export interface SyncBankAccountsResponse {
  accounts: BankAccount[];
  synced_at: string;
}

export interface SetDefaultBankAccountRequest {
  bank_account_id: string;
}

export interface SetDefaultBankAccountResponse {
  ok: boolean;
  default_bank_account_id: string;
}

export interface DisableBankAccountRequest {
  reason_code: string;
  reason_text?: string;
  replacement_default_bank_account_id?: string;
}

export interface DisableBankAccountResponse {
  ok: boolean;
}

export const companyPaymentsEndpoints = {
  // Create Plaid link token for company
  createCompanyLinkToken: () =>
    apiClient.post<LinkTokenResponse>('/api/payments/company/link_token'),

  // S-B6: Create Plaid link token for update mode (reconnecting)
  createCompanyUpdateLinkToken: () =>
    apiClient.post<LinkTokenResponse>('/api/payments/company/link_token/update'),

  // Exchange Plaid public token after successful Link flow for company
  exchangeCompanyPublicToken: (publicToken: string) =>
    apiClient.post<ExchangePublicTokenResponse>('/api/payments/company/exchange_public_token', {
      public_token: publicToken,
    }),

  // Get company payment profile status
  getCompanyProfile: () =>
    apiClient.get<CompanyPaymentProfileResponse>('/api/payments/company/profile'),

  // S-B4: List company bank accounts
  listCompanyBankAccounts: () =>
    apiClient.get<BankAccountsResponse>('/api/payments/company/bank_accounts'),

  // S-B4: Sync company bank accounts from provider
  syncCompanyBankAccounts: () =>
    apiClient.post<SyncBankAccountsResponse>('/api/payments/company/bank_accounts/sync'),

  // S-B5: Set default company bank account
  setDefaultCompanyBankAccount: (bankAccountId: string) =>
    apiClient.post<SetDefaultBankAccountResponse>('/api/payments/company/bank_accounts/default', {
      bank_account_id: bankAccountId,
    }),

  // S-B7: Disable company bank account
  disableCompanyBankAccount: (bankAccountId: string, request: DisableBankAccountRequest) =>
    apiClient.post<DisableBankAccountResponse>(`/api/payments/company/bank_accounts/${bankAccountId}/disable`, request),
};
